import { createTheme } from '@mui/material/styles'

export const SANS = "'Instrument Sans', system-ui, sans-serif"
export const MONO = "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace"

// The design's colour tokens. They land on `palette.custom`, so any component can
// reach them through sx string paths — sx resolves `color`, `bgcolor` and
// `borderColor` against `theme.palette` by dotted path.
const TOKENS = {
  light: {
    paper: '#f5f5f2',
    rail: '#fbfbf9',
    surface: '#ffffff',
    bar: '#fbfbf9',
    line: '#e4e3de',
    lineSoft: '#f1f1ed',
    field: '#fbfbf9',
    fieldLine: '#e0dfda',
    hover: '#fafaf8',
    chip: '#eeeee9',
    ink: '#17181b',
    ink2: '#4d525a',
    ink3: '#6b6f77',
    ink4: '#8c8f96',
    inkDisabled: '#c9c9c3',
    invertInk: '#fbfbf9',
    up: '#1f6f4f',
    upText: '#1a6146',
    upFlash: '#f2f8f4',
    downText: '#963026',
    downFlash: '#fdf4f3',
    track: '#f1f1ed',
  },
  dark: {
    paper: '#131417',
    rail: '#0e0f12',
    surface: '#191a1e',
    bar: '#15161a',
    line: '#292b31',
    lineSoft: '#212328',
    field: '#1d1f24',
    fieldLine: '#30333a',
    hover: '#1f2126',
    chip: '#24262c',
    ink: '#eceef1',
    ink2: '#b2b7c0',
    ink3: '#9aa0aa',
    ink4: '#7f858f',
    inkDisabled: '#4a4e56',
    invertInk: '#131417',
    up: '#43b98f',
    upText: '#5fcba3',
    upFlash: '#16241f',
    downText: '#f1867b',
    downFlash: '#271a1a',
    track: '#23252b',
  },
}

export function createAppTheme(mode) {
  const c = TOKENS[mode] ?? TOKENS.light

  return createTheme({
    palette: {
      mode,
      custom: c,
      background: { default: c.paper, paper: c.surface },
      text: { primary: c.ink, secondary: c.ink2, disabled: c.inkDisabled },
      divider: c.line,
      primary: { main: c.up, contrastText: c.invertInk },
    },

    shape: { borderRadius: 7 },

    typography: {
      fontFamily: SANS,
      button: { textTransform: 'none', fontWeight: 600 },
    },

    components: {
      // The design has no ripple anywhere.
      MuiButtonBase: { defaultProps: { disableRipple: true } },

      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFeatureSettings: "'tnum' 1",
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
          },
        },
      },

      // Rows draw their own separators, and every cell sets its own padding.
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: 'none',
            padding: '0 12px',
            fontSize: 'inherit',
            color: 'inherit',
            fontFamily: 'inherit',
          },
        },
      },

      MuiTooltip: {
        defaultProps: { arrow: false },
      },
    },
  })
}
